import React, { createContext, useContext, useState, ReactNode } from 'react';

interface BreadcrumbItem {
  label: string;
  path?: string;
  onClick?: () => void;
}

interface HeaderContextType {
  pageTitle: string;
  setPageTitle: (title: string) => void;
  showBackButton: boolean;
  setShowBackButton: (show: boolean) => void;
  backButtonAction: (() => void) | null;
  setBackButtonAction: (action: (() => void) | null) => void;
  breadcrumbs: BreadcrumbItem[];
  setBreadcrumbs: (breadcrumbs: BreadcrumbItem[]) => void;
  showBreadcrumbs: boolean;
  setShowBreadcrumbs: (show: boolean) => void;
}

const HeaderContext = createContext<HeaderContextType | undefined>(undefined);

export const useHeader = () => {
  const context = useContext(HeaderContext);
  if (context === undefined) {
    throw new Error('useHeader must be used within a HeaderProvider');
  }
  return context;
};

interface HeaderProviderProps {
  children: ReactNode;
}

export const HeaderProvider: React.FC<HeaderProviderProps> = ({ children }) => {
  const [pageTitle, setPageTitle] = useState('');
  const [showBackButton, setShowBackButton] = useState(false);
  const [backButtonAction, setBackButtonAction] = useState<(() => void) | null>(null);
  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbItem[]>([]);
  const [showBreadcrumbs, setShowBreadcrumbs] = useState(false);

  const value = {
    pageTitle,
    setPageTitle,
    showBackButton,
    setShowBackButton,
    backButtonAction,
    setBackButtonAction,
    breadcrumbs,
    setBreadcrumbs,
    showBreadcrumbs,
    setShowBreadcrumbs,
  };

  return (
    <HeaderContext.Provider value={value}>
      {children}
    </HeaderContext.Provider>
  );
}; 